export default __webpack_public_path__ + "static/media/gallery_11.04a47312.jpg";